export default "__VITE_ASSET__Dl8TtmLZ__"